import {
    autoUpdate,
    flip,
    offset,
    shift,
    useClick,
    useDismiss,
    useFloating,
    useInteractions,
    useRole,
} from "@floating-ui/react";
import { useState } from "react";

/**
 * Positioning + open/close for an Action-required bucket popup (Errors, Manual Actions).
 * Delegates outside-click and Escape handling to floating-ui's useDismiss (no manual document
 * listeners), and opens to the right of the card, flipping and shifting to stay in the viewport
 * (e.g. the tablet filters drawer).
 */
const useBucketPopup = (disabled: boolean) => {
    const [isOpen, setIsOpen] = useState(false);

    const { refs, floatingStyles, context } = useFloating({
        open: isOpen,
        onOpenChange: setIsOpen,
        placement: "right-start",
        middleware: [offset(8), flip(), shift({ padding: 8 })],
        whileElementsMounted: autoUpdate,
    });

    const click = useClick(context, { enabled: !disabled });
    const dismiss = useDismiss(context);
    const role = useRole(context);
    const { getReferenceProps, getFloatingProps } = useInteractions([click, dismiss, role]);

    return { isOpen, refs, floatingStyles, getReferenceProps, getFloatingProps };
};

export default useBucketPopup;
